import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { HostListener } from '@angular/core';

@Component({
    selector: 'app-new-folder',
    templateUrl: './new-folder.component.html',
    styleUrls: ['./new-folder.component.css'],
    standalone: false
})
export class NewFolderComponent implements OnInit {

  form: UntypedFormGroup;
  name: string = "";

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.key
    if(event.key === "Enter"){
      this.save();
    }
  }

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<NewFolderComponent>) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.name, [Validators.required, Validators.minLength(1), Validators.maxLength(128)]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
